import {Signboard} from '../../../DTO/SignboardDTO'
import React from 'react'
import {Line} from '../../Atoms/Line'
import {formatPrice} from '../../../../Common/Formatter'
import {ContractTerm} from '../../../Props/ContractInputInfo'
import {MBContentFlexWrapTypography, MBContentSubTitleTypography} from '../../Atoms/Typographies'
import {PIMCard} from '../../Atoms/Cards/PIMCard'
import {Spacer} from '../../../../Common/Components/Spacer'
import {BorderedContentBlock} from '../../Molecules/BaseContentBlocks/ContentBlock'
import {PIMStack} from '../../Atoms/Layouts/Bases/PIMStack'
import {MBListItem, MBUnorderedList} from '../../Atoms/Lists/MBList'
import {SignedUpSignboard} from '../../../DTO/SignedUpSignboardDTO'
import {useTranslation} from 'react-i18next'

export type PaymentInformation = {
  isFreeBucket: boolean
  termName: string
  contractAmount: number
  order: number
  term: ContractTerm
}

export type RegisterOrganizationContentBlockProps = {
  signboard: Signboard | SignedUpSignboard
  title: string
  paymentInformationList: PaymentInformation[]
}

export const RegisterOrganizationContentBlock: React.VFC<RegisterOrganizationContentBlockProps> = (
  props,
) => {
  return (
    <PIMCard
      headerProps={{title: props.title, logoUrl: props.signboard.logoImgUrl}}
      testId={'block-register-organization'}
      pb={'24px'}
    >
      <MBUnorderedList data-testid={'block-register-organization-main-service'}>
        <MBListItem>
          <MBContentSubTitleTypography>
            <Line>{props.signboard.mainService.name}</Line>
            <SubTitleContent
              paymentInformationList={props.paymentInformationList}
            />
          </MBContentSubTitleTypography>
        </MBListItem>
      </MBUnorderedList>
      <FreeBucketsBlock signboard={props.signboard}/>
    </PIMCard>
  )
}

const getResultContractUnits = (paymentInformationList: PaymentInformation[]): string => {
  paymentInformationList.sort((a, b) => a.order - b.order)

  const paymentDisplayStringList = paymentInformationList.map(item => {
    return `${item.termName}：${formatPrice(item.contractAmount)}円(税込)`
  })

  return Array.from(new Set(paymentDisplayStringList)).join(' ／ ')
}

type SubTitleContentProps = {
  paymentInformationList: PaymentInformation[]
}
const SubTitleContent: React.VFC<SubTitleContentProps> = (
  {
    paymentInformationList,
  },
) => {
  if (!paymentInformationList) {
    return <></>
  }

  const isFreeBucket = paymentInformationList.some(payInfo => payInfo.isFreeBucket)
  if (isFreeBucket) {
    return <></>
  }

  const resultContractUnits = getResultContractUnits(paymentInformationList)
  if (resultContractUnits.length > 0) {
    return <Line>{resultContractUnits}</Line>
  }

  return <></>
}

type FreeBucketsBlockProps = {
  signboard: Signboard,
}
const FreeBucketsBlock: React.VFC<FreeBucketsBlockProps> = ({signboard}) => {
  const {t} = useTranslation('member')
  const freeServices = signboard.freeServices
  if (freeServices.length === 0) return null

  return <Spacer mt={'24px'}>
    <BorderedContentBlock data-testid={'block-register-organization-free-services'}>
      <PIMStack spacing={2}>
        <MBContentSubTitleTypography>
          {t('新規登録情報入力.入会バケット情報.無料付帯バケット.見出し')}
        </MBContentSubTitleTypography>
        <MBUnorderedList>
          {freeServices.map(bucket =>
            <MBListItem key={bucket.id}>
              <MBContentFlexWrapTypography>
                {bucket.name}
                <SignedUpTypography signedUp={bucket.signedUp}/>
              </MBContentFlexWrapTypography>
            </MBListItem>)
          }
        </MBUnorderedList>
      </PIMStack>
    </BorderedContentBlock>
  </Spacer>
}

type SignedUpTypographyProps = {
  signedUp: boolean
}
const SignedUpTypography: React.VFC<SignedUpTypographyProps> = (
  {
    signedUp,
  },
) => {
  if (!signedUp) return <></>

  return (
    <span>{' [入会済]'}</span>
  )
}
